import React from 'react'
import Box from '@mui/material/Box'

const COLORS = [
  '#3B82F6', '#EF4444', '#10B981', '#F59E0B', '#8B5CF6',
  '#EC4899', '#06B6D4', '#F97316', '#6366F1', '#14B8A6',
  '#E11D48', '#0EA5E9', '#84CC16', '#A855F7', '#D946EF',
]

interface Props {
  value: string
  onChange: (color: string) => void
}

export function ColorPicker({ value, onChange }: Props) {
  return (
    <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
      {COLORS.map((color) => (
        <Box
          key={color}
          onClick={() => onChange(color)}
          sx={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            backgroundColor: color,
            cursor: 'pointer',
            border: value === color ? '3px solid' : '2px solid transparent',
            borderColor: value === color ? 'text.primary' : 'transparent',
            outline: value === color ? '2px solid white' : 'none',
            outlineOffset: '-3px',
            transition: 'transform 0.1s',
            '&:hover': {
              transform: 'scale(1.15)',
            },
          }}
        />
      ))}
    </Box>
  )
}
